<template>
  <div
    v-if="!$template.disabled_campaign_title"
    class="title campaign-title !my-1 lg:!my-4 text-normal"
    v-html="tagText($template.campaign_title)"
  ></div>
  <div v-if="$template">
    <HeaderEntry />
    <!-- <Bandit v-if="$template.campaign_template_mechanic_id === 2" @endGame="isGameFinish = true" :code="null" :alreadyPlay="false"/> -->
    <div class="w-[80%] lg:w-full mt-4 pb-6 flex justify-center text-base lg:text-xl mx-auto">
      <button class="button-validation lg:!p-3" @click="goToProduct()" v-html="tagText($template.campaign_button)">
      </button>
    </div>
  </div>
</template>

<script>
import HeaderEntry from '../common/components/HeaderEntry.vue'
import InputText from '../common/components/Inputs/InputText.vue'
import InputSelect from '../common/components/Inputs/InputSelect.vue'
// import Bandit from '../common/components/Bandit.vue'
import { ErrorMessage, Field, Form } from 'vee-validate'
import moment from 'moment'

export default {
  name: 'EntryBView',
  components: {
    HeaderEntry,
    InputText,
    InputSelect,
    ErrorMessage,
    Form,
    Field,
    // Bandit
  },
  emits: ['openModal', 'openNotification'],
  data: () => ({
    errors: [],
    form: {},
    isGameFinish : false,
  }),
  methods: {
    openModal(title, message, img) {
      this.$emit('openModal', title, message, img)
    },
    goToProduct() {
      this.$router.replace({ name: 'product' })
    }
  },
}
</script>

<style scoped>
.campaign-title {
  background-color: v-bind(
    "$template ? $template.campaign_title_background_color : ''"
  );
}

.button-validation {
  background-color: v-bind(
    "$template ? $template.campaign_button_background_color : ''"
  );
  color: v-bind("$template ? $template.campaign_button_text_color : ''");
}

.campaign-container {
  background-color: v-bind(
    "$template && !$template.disabled_campaign_text ? $template.campaign_text_background_color : ''"
  );
}

.campaign-container {
  @apply p-8;
}

.div-form {
  @apply lg:flex  w-full mt-3;
}

.input-form {
  @apply lg:w-1/2 lg:mr-4 mt-3 lg:mt-0;
}
</style>
